/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import RadiationType from './radiation-type';
import RadiationTypeDetail from './radiation-type-detail';
import RadiationTypeUpdate from './radiation-type-update';
import RadiationTypeDeleteDialog from './radiation-type-delete-dialog';

const RadiationTypeRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<RadiationType />} />
    <Route path="new" element={<RadiationTypeUpdate />} />
    <Route path=":id">
      <Route index element={<RadiationTypeDetail />} />
      <Route path="edit" element={<RadiationTypeUpdate />} />
      <Route path="delete" element={<RadiationTypeDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default RadiationTypeRoutes;
